import { render, staticRenderFns } from "./SummarySourcesCard.vue?vue&type=template&id=12c3c3c6&scoped=true"
import script from "./SummarySourcesCard.vue?vue&type=script&lang=js"
export * from "./SummarySourcesCard.vue?vue&type=script&lang=js"
import style0 from "./SummarySourcesCard.vue?vue&type=style&index=0&id=12c3c3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3c3c6",
  null
  
)

export default component.exports